






























































import { Ability } from '@casl/ability'
import { Button } from 'element-ui'
import { Component, Vue, Prop } from 'vue-property-decorator'

import BookingPassengerBlock from '@/components/BookingPassengerBlock.vue'
import PassengerDetailsModal from '@/components/PassengerDetailsModal.vue'
import PassengerForm from '@/components/PassengerForm.vue'
import RoundAvatar from '@/components/RoundAvatar.vue'

import Booking from '@/models/booking'
import Customer from '@/models/customer'
import Passenger, {
  PassengerInfoStatuses,
  PassengerStatuses,
} from '@/models/passenger'

@Component({
  components: {
    PassengerDetailsModal,
    PassengerForm,
    RoundAvatar,
    BookingPassengerBlock,
    [Button.name]: Button,
  },
})
export default class BookingPassenger extends Vue {
  @Prop() passenger!: Passenger
  @Prop() booking!: Booking
  @Prop() ability!: Ability
  @Prop() currentCustomer!: Customer
  @Prop() isPassengerGuest!: boolean

  modalVisible = false
  invitationSent = false

  get passengerInfoIsComplete(): boolean {
    return this.passenger.personalInfoStatus === PassengerInfoStatuses.Complete
  }

  get isLead(): boolean {
    return this.booking.customerId === this.passenger.customerId
  }

  get currentCustomerIsLead(): boolean {
    return this.ability.can('update', this.booking)
  }

  get passengerCancelled(): boolean {
    return this.passenger.passengerStatus === PassengerStatuses.Cancelled
  }

  handlePassengerEdit(passenger: Passenger) {
    const updatedPassenger = {
      ...this.passenger,
      ...passenger,
    }
    this.$emit('on-passenger-update', updatedPassenger)
    this.modalVisible = false
  }

  sendInvitation() {
    this.$emit('on-resend-invitation', this.passenger.id)
    this.invitationSent = true
  }

  get caption() {
    return this.passengerInfoIsComplete && this.passenger.canBeChanged
      ? 'UPDATE DETAILS'
      : 'ADD DETAILS'
  }

  onModalClose() {
    this.modalVisible = false
    this.invitationSent = false
  }
}
